import { Component, Input } from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { IconColor } from '@shared/models/step.model';
import { IconFrame } from '@app/icon-library/lib/pl-icon.component';

@Component({
  selector: 'pl-icon-custom-control',
  templateUrl: './icon-custom-control.component.html',
})
export class IconCustomControlComponent {
  @Input({ required: true }) public isDirty!: boolean;
  @Input({ required: true }) public isDisabled!: boolean;
  @Input({ required: true }) public isFocused!: boolean;
  @Input({ required: true }) public isFormSubmitted!: boolean;
  @Input({ required: true }) public isValid!: boolean;

  public readonly IconFrame: typeof IconFrame = IconFrame;
  public readonly IconColor: typeof IconColor = IconColor;
  public readonly PlIcon: typeof PlIcon = PlIcon;
}
